import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as types from './types';
import { getWishlist, postItem, deleteItem } from '../../../services/wishlist';
export default {
  getWishlist(_ref) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      commit(types.SET_LOADING_WISHLIST, true);
      const data = yield getWishlist(_this);
      commit(types.SET_WISHLIST, data);
      commit(types.SET_LOADING_WISHLIST, false);
    })();
  },

  postItem(_ref2, payload) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref2;
      commit(types.ADD_WISHLIST_ITEM, payload);
      postItem(_this2, payload).catch(err => {
        console.error('Wishlist add error', err);
      });
    })();
  },

  deleteItem(_ref3, payload) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;
      commit(types.DELETE_WISHLIST_ITEM, payload);
      deleteItem(_this3, payload).catch(err => {
        console.error('Wishlist delete error', err);
      });
    })();
  }

};